<template>
  <div class="marketing-email-editor">
    <div
      v-show="!viewOnly && isLoaded"
      class="marketing-email-editor-actions"
      id="externalSystemContainer"
    >
      <button id="undoButton" class="btn marketing-email-editor-actions-item">
        <i class="mdi mdi-undo pointer"></i>
      </button>
      <button id="redoButton" class="btn marketing-email-editor-actions-item">
        <i class="mdi mdi-redo pointer"></i>
      </button>
      <!-- <button
        id="historyId"
        class="btn marketing-email-editor-actions-item"
      ></button> -->
      <button
        id="codeEditor"
        class="btn marketing-email-editor-actions-item"
        type="button"
      >
        <i class="mdi mdi-code-tags"></i>
      </button>

      <dropdown
        class="marketing-email-editor-actions-variable"
        data-icon="mdi-code-braces"
      >
        <p class="marketing-email-editor-actions-variable-help">
          {{ $t("message.marketingGenerics.message.tooltipFirstName") }}
        </p>
        <p class="marketing-email-editor-actions-variable-options">
          {PRIMEIRO_NOME}
        </p>
      </dropdown>

      <button
        id="codeEditor"
        class="btn marketing-email-editor-actions-item marketing-email-editor-actions-item_email"
        type="button"
        @click="openTestModal"
      >
        <svgicon
          icon="email-arrow-right-outline"
          width="15"
          height="15"
          color="#4d4d4d"
        ></svgicon>
      </button>

      <span
        class="btn marketing-email-editor-actions-item"
        id="changeHistoryContainer"
        style="display: none"
        >Last change: <a id="changeHistoryLink"></a
      ></span>

      <button
        class="btn marketing-email-editor-actions-item"
        type="button"
        @click="emitConfig"
      >
        {{ $t("message.generics.message.settings") }}
      </button>
    </div>

    <div
      v-show="isLoaded"
      class="marketing-email-editor-container"
      :class="{ 'marketing-email-editor-container_view': viewOnly }"
    >
      <div id="stripoSettingsContainer"></div>

      <div id="stripoPreviewContainer"></div>
    </div>

    <loading class="marketing-email-editor-loading" v-show="!isLoaded" />

    <marketing-email-test v-model="showTestModal" :item="email" />
  </div>
</template>

<script>
import Dropdown from "@components/Dropdown";
import MarketingEmailTest from "@components/modules/marketing/email/test/MarketingEmailTest";
import Loading from "@components/generic/Loading";
import stripo from "@packages/mixins/stripo";

export default {
  components: {
    Loading,
    MarketingEmailTest,
    Dropdown,
  },

  mixins: [stripo],

  props: {
    email: {
      type: Object,
      required: true,
    },
    value: {
      type: Object,
      default: undefined,
    },
    viewOnly: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      isLoaded: false,
      showTestModal: false,
      credentials: undefined,
      authApi: undefined,
    };
  },

  beforeDestroy() {
    this.compile();
    this.stopPlugin();
  },

  mounted() {
    this.initPlugin({
      html: this.value.htmlContent,
      css: this.value.cssStyle,
    });
  },

  methods: {
    async compile() {
      await this.$api.marketing.email.message.compile({
        emailId: this.email.id,
        credentials: this.authApi,
      });
    },
    async openTestModal() {
      this.compile();
      this.showTestModal = true;
    },
    emitInput(val) {
      this.$emit("input", val);
    },
    async emitConfig() {
      await this.compile();
      this.$emit("config");
    },
  },
};
</script>

<style lang="scss" scoped>
.marketing-email-editor {
  position: relative;

  .marketing-email-editor-actions {
    position: absolute;
    right: 10px;
    top: 10px;
    z-index: 10;
    display: flex;

    .marketing-email-editor-actions-variable {
      font-size: 12px;
      margin-right: 10px;

      ::v-deep .dropdown-btn {
        padding: 5px 15px;
        display: flex;
        justify-content: center;
        background: white;
        border: 1px solid #c4c4c4;
      }

      ::v-deep .dropdown-icon {
        margin: 0;
        font-size: 13px;
      }

      .marketing-email-editor-actions-variable-help {
        margin-bottom: 10px;
      }

      .marketing-email-editor-actions-variable-options {
        margin: 0;
      }
    }

    .marketing-email-editor-actions-item {
      background: #fff;
      box-shadow: none;
      border: 1px solid #c4c4c4;
      font-size: 13px;
      padding: 5px 15px;
      margin-right: 10px;

      &.marketing-email-editor-actions-item_email {
        display: flex;
        align-items: center;
      }

      &:last-child {
        margin-right: 0;
      }
    }
  }

  .marketing-email-editor-container {
    display: flex;

    #stripoSettingsContainer {
      width: 400px;
      border: 1px solid #c4c4c4;
      border-right: none;

      .sripo-watermark {
        display: none;
      }
    }

    #stripoPreviewContainer {
      flex: 1;
      background: #f2f2f2;
      border: 1px solid #c4c4c4;
      padding-top: 55px;
    }

    &.marketing-email-editor-container_view {
      #stripoPreviewContainer {
        padding-top: 0;
      }
    }
  }

  .marketing-email-editor-loading {
    margin: 30px auto;
    width: 30px;
    height: 30px;
  }
}
</style>
